import { request } from './repository';

const url = 'organizations/';

const organizationsRepository = {
    getOrganizations(params) {
        return request.get(url, params);
    },
    storeOrganization(data) {
        return request.post(url, data);
    },
    updateOrganization(id, data) {
        return request.put(url + id, data);
    },
    deleteOrganization(id) {
        return request.delete(url + id);
    }
}

export default organizationsRepository;